export default {
    breadcrumbs: {
        home: 'Početna',
        contact: 'Kontakt',
    },
    heading: 'Kontakt stranica',
    contact: 'Kontakt',
    contact_us: 'Kontaktirajte nas',
    description_1: 'Uvek je lepo čuti od vas.',
    description_2:
        'Popunite formular na desnoj strani, a mi ćemo vam se javiti u najkraćem mogućem roku. Tokom radnog vremena očekujte odgovor u roku od 24h.',
    description_3: 'Ako problem ne može da čeka toliko dugo, ne brinite! Posvećeni smo i van radnog vremena za hitne slučajeve.',
    phone: 'Telefon',
    email: 'Email',
    address: 'Adresa',
    support: 'Zakaži sastanak',
}
